import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { MERCHANT_PROFILE } from '@/constants/merchantDashboardData';
import { useAuth } from '@/store/AuthContext';

/** Avatar + name in the header's top-right corner; opens a profile card with account details and sign out. */
export function ProfileMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const name = user?.full_name || user?.username || 'Account';
  const role = user?.roles?.[0] ?? 'USER';
  const isMerchant = user?.roles?.includes('MERCHANT') ?? false;
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.admin.login, { replace: true });
  };

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="link"
        id="profile-menu"
        className="d-flex align-items-center gap-2 text-decoration-none p-1 pe-2 rounded-pill bg-surface-low border-0"
        aria-label="Open profile menu"
      >
        <span
          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-semibold flex-shrink-0"
          style={{ width: 36, height: 36 }}
        >
          {initials || '?'}
        </span>
        <span className="d-none d-md-flex flex-column text-start lh-sm">
          <span className="text-label-md text-on-surface">{name}</span>
          <span className="text-label-sm text-on-surface-variant text-capitalize">{role.toLowerCase()}</span>
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="shadow-kiosk-md border-0 rounded-4 p-0 mt-2" style={{ width: 320 }}>
        <div className="p-3 d-flex align-items-center gap-3">
          <span
            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-semibold flex-shrink-0"
            style={{ width: 52, height: 52, fontSize: 18 }}
          >
            {initials || '?'}
          </span>
          <div style={{ minWidth: 0 }}>
            <div className="text-label-lg text-on-surface text-truncate">{name}</div>
            <div className="text-body-sm text-on-surface-variant text-truncate">{user?.username}</div>
            <span className="badge rounded-pill bg-primary-subtle text-primary mt-1">{role}</span>
          </div>
        </div>

        {isMerchant && (
          <div className="px-3 pb-3 d-flex flex-column gap-2 text-body-sm">
            <div className="d-flex gap-2 text-on-surface-variant">
              <i className="bi bi-building" />
              <span className="text-on-surface">{MERCHANT_PROFILE.businessName}</span>
            </div>
            <div className="d-flex gap-2 text-on-surface-variant">
              <i className="bi bi-geo-alt" />
              <span>{MERCHANT_PROFILE.city}</span>
            </div>
            <div className="d-flex gap-2 text-on-surface-variant">
              <i className="bi bi-calendar-check" />
              <span>Member since {MERCHANT_PROFILE.since}</span>
            </div>
            <div className="d-flex gap-2 text-on-surface-variant">
              <i className="bi bi-clock-history" />
              <span>Last login {MERCHANT_PROFILE.lastLogin}</span>
            </div>
          </div>
        )}

        <div className="border-top p-2">
          <Dropdown.Item as="button" onClick={handleLogout} className="rounded-3 d-flex align-items-center gap-2 text-danger py-2">
            <i className="bi bi-box-arrow-right" />
            Sign out
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
